import React from "react";
import ModalWrapper from "./ModalWrapper";
import { ASSETS } from "../../utils/config";

function WarningClonePopup({
  isOpen,
  handleClose,
  title = "Disable Sync Clones",
  children,
  buttonText = "Accept",
  repeatButtonText = null,
  cancelButtonText = "Cancel",
  onRepeat = () => {},
  onAccept = ()=>{}
}) {
  return (
    <ModalWrapper
      isOpen={isOpen}
      handleClose={handleClose}
      iconKey="warning"
      title={title}
      buttonText={buttonText}
      repeatButtonText={repeatButtonText}
      cancelButtonText={cancelButtonText}
      onRepeat={onRepeat}
      onSubmit={onAccept}
      prefixIcon={ASSETS.BroadCastUpdateYellowIcon}
    >
      {children}
    </ModalWrapper>
  );
}

export default WarningClonePopup;
